import { Pages } from '@/constants/rutas';

export const SeoTitles = {
    [Pages.ESTADISTICAS_FANTASY_JUGADORES]: 'Estadísticas de Fútbol de La Liga Fantasy',
    [Pages.MERCADO]: 'Subidas y bajadas de valor de mercado diarias de La Liga Fantasy Dazn',
    [Pages.MERCADO_EQUIPOS]: 'Subidas y bajadas de mercado de equipos de La Liga Fantasy Dazn',
    [Pages.INICIO]: 'Alineaciones probables - Liga Fantasy Fútbol - Analítica Fantasy',
    [Pages.NOTICIAS]: 'Noticias de fantasy fútbol, actualidad de mercado y análisis de jugadores',
    [Pages.ANALIZA_TU_PLANTILLA]: 'Análisis de plantillas en clave Fútbol La Liga Fantasy',
    [Pages.COMPARADOR_DE_JUGADORES]: 'Comparador de jugadores de fútbol en clave fantasy',
    [Pages.LESIONADOS_SANCIONADOS_APERCIBIDOS]:
        'Jugadores Lesionados, Sancionados y Apercibidos en Clave Fantasy',
    [Pages.CLASIFICACION]: 'Clasificación de Equipos de La Liga: Posición, Goles y Más',
    [Pages.ONCE_IDEAL]: 'Once ideal, rentable y MVP en clave La Liga Fantasy Dazn',
    [Pages.LANZADORES_PENALTIS]: 'Estadísticas de pateadores de penalti de La Liga',
    [Pages.ESTADISTICAS_DEL_JUGADOR_DEFAULT]: 'Estadísticas de jugadores de fútbol en clave La Liga Fantasy',
    [Pages.LIDERES_POR_JORNADAS]: 'Líderes en estadísticas, goles, asistencias, puntos Fantasy',
    [Pages.MEJORES_RACHAS]: 'Mejores rachas de puntos fantasy en clave La Liga Fantasy Fútbol',
    [Pages.INICIA_SESION]: 'Iniciar sesión en Analitica Fantasy',
    [Pages.REGISTRATE]: 'Regístrarse en Analitica Fantasy',
    [Pages.MIS_PLANTILLAS]: 'Mis Plantillas de Fútbol La Liga Fantasy',
    [Pages.EDITAR_PLANTILLA]: 'Editar Plantilla de Fútbol La Liga Fantasy',
    [Pages.CREAR_PLANTILLA]: 'Crear Plantillas de La Liga Fantasy, Fantasy Marca, Biwenger',
    [Pages.TERMINOS_CONDICIONES]: 'Términos y condiciones de Analitica Fantasy',
    [Pages.POLITICAS_PRIVACIDAD]: 'Política de privacidad de Analitica Fantasy',
    [Pages.CONTACTANOS]: 'Contáctanos y te ayudaremos en Analitica Fantasy',
    [Pages.PARTIDO]: 'PARTIDO | Analitica Fantasy',
    [Pages.CALENDARIO_FANTASY]: 'Equipos con mejor calendario para La Liga Fantasy',
    [Pages.REESTABLECER_CONTRASENA]: 'Reestablecer contraseña de Analitica Fantasy',
    [Pages.ANALISIS_PLANTILLA]: 'Análisis Plantilla de La Liga Fantasy, Fantasy Marca, Biwenger',
    [Pages.ENCUESTA_DE_SATISFACCION]: 'Encuesta de satisfacción de Analítica Fantasy',
    [Pages.PERFIL_DE_USUARIO]: 'Perfil de usuario de Analítica Fantasy',
    [Pages.OLVIDASTE_TU_CONTRASENA]: '¿Olvidaste tu contraseña? en Analítica Fantasy',
    [Pages.FANTASY_MANAGER]: 'Fantasy Manager de La Liga Fantasy, Fantasy Marca, Biwenger',
    [Pages.PREDICTING_MANAGER]: 'Predicting Manager de Fútbol La Liga Fantasy | Analítica Fantasy',
    [Pages.PREDICTING_MANAGER_RANKING]: 'Ranking de managers de Predicting Manager | Analítica Fantasy',
    [Pages.ADMINISTRADOR_JUGADORES]: 'Administrador de jugadores de Analítica Fantasy',
    [Pages.PREDICTING_MANAGER_ALINEACIONES]: 'Alineaciones probables de los managers de Predicting Manager',
    [Pages.PREDICTING_MANAGER_RULES]: 'Reglas del Predicting Manager de fútbol de Analítica Fantasy',
    [Pages.COLABORADORES]: 'Colaboradores de Analítica Fantasy',
    [Pages.COLABORADORES_NOTICIAS]: 'Noticias de colaboradores de Analítica Fantasy',
    [Pages.JUGADORES]: 'Perfil del jugador en clave Fantasy. | Analítica Fantasy',
    [Pages.QUINIELA_JUEGO]: 'Juega la Quiniela Analítica | Analítica Fantasy',
    [Pages.PUJA_FANTASY]: 'Puja ideal para cada jugador de La Liga Fantasy | Analítica Fantasy',
    [Pages.PUJA_FANTASY_BIWENGER]: 'Puja ideal para cada jugador de Fantasy Biwenger | Analítica Fantasy',
    [Pages.QUINIELA_CLASIFICACION]: 'Clasificación de la Quiniela Analítica | Analítica Fantasy',
    [Pages.QUINIELA_REGLAS_DEL_JUEGO]: 'Reglas del juego de la Quiniela Analítica de Analítica Fantasy',
    [Pages.JUGADORES_LESIONADOS]: 'Jugadores lesionados de La Liga Fantasy | Analítica Fantasy',
    [Pages.JUGADORES_SANCIONADOS]: 'Jugadores sancionados de La Liga Fantasy | Analítica Fantasy',
    [Pages.JUGADORES_DUDAS]: 'Jugadores en dudas de La Liga Fantasy | Analítica Fantasy',
    [Pages.JUGADORES_APERCIBIDOS]: 'Jugadores apercibidos de La Liga Fantasy | Analítica Fantasy',
    [Pages.NOTICIAS_FLASH]: 'Jugadores lesionados y sancionados en clave Fútbol Fantasy',
    [Pages.CALENDARIO_COMPETICIONES]: 'Calendario de competiciones de fútbol | Analítica Fantasy',
    [Pages.CONVOCATORIAS]: 'Convocatoria del partido | Analítica Fantasy',
    [Pages.VIRUS_FIFA]: 'Jugadores de fantasy fútbol convocados por sus selecciones',
    [Pages.APUESTAS_DEPORTIVAS]: 'Apuestas deportivas | Analítica Fantasy',
    [Pages.MERCADO_FICHAJES]: 'Mercado de fichajes de fùtbol de La Liga',
    [Pages.MERCADO_BIWENGER]: 'Subidas y bajadas diarias de mercado de Fantasy Biwenger',
    [Pages.ESTADISTICAS_BIWENGER]: 'Estadísticas de jugadores de fútbol en clave Fantasy Biwenger',
    [Pages.LIDERES_ESTADISTICAS]: 'Líderes de estadísticas de La Liga Fantasy',
    [Pages.INSTALL_APP]: 'Descarga nuestra app de Analítica Fantasy',
    [Pages.PREMIOS_Y_SORTEOS]: 'Premios y sorteos de fantasy fútbol en Analítica Fantasy',
    [Pages.ACTIVIDADES]: 'Resumen de fantasy fútbol en Analítica Fantasy',
    [Pages.SALON_DE_LA_FAMA]: 'Salón de la fama de Analítica Fantasy',
    [Pages.CHOLLOS_FANTASY_BIWENGER]: 'Chollos fantasy de Biwenger',
    [Pages.CHOLLOS_FANTASY_RELEVO]: 'Chollos de La Liga Fantasy Dazn',
    [Pages.QUEDADA_FANTASY]: 'Quedada Fantasy 2024 | Analítica Fantasy',
    [Pages.TIER_LIST]: 'Gestiona tus tierlist de jugadores de fantasy fútbol',
    [Pages.TIER_LIST_PUBLIC]: 'Consulta las tierlists de Analítica Fantasy',
    [Pages.NUEVA_TIER_LIST]: 'Crea tu tierlist de jugadores de fantasy fútbol',
    [Pages.EDIT_TIER_LIST]: 'Edita tu tierlist de jugadores de fantasy fútbol',
    [Pages.VISUALIZAR_TIER_LIST]: 'Visualiza tu tierlist de jugadores de fantasy fútbol',
    [Pages.FANTASY_DAZN_FALLECIO]: 'Fantasy Dazn estiró la pata',
    [Pages.KIT_DIGITAL]: 'Kit Digital de Analítica Fantasy',
    [Pages.ORACULO_FANTASY]: 'Oráculo de La Liga Fantasy',
    [Pages.SITIOS_RECOMENDADOS]: 'Sitios recomendados de Analítica Fantasy',
    [Pages.CREADORES_CONTENIDO]: 'Creadores de contenido en Analítica Fantasy',
    [Pages.PUNTUACIONES_FANTASY]: 'Puntuaciones de LaLiga Fantasy de cada jornada',
    [Pages.PREPARADOR_JORNADA]: 'Preparador de Jornada de La Liga Fantasy',
    [Pages.ALINEACIONES_PROBABLES]: 'Alineaciones probables de La Liga Fantasy: Jornada actual',
    [Pages.NOVEDADES]: 'Últimas Novedades de Analítica Fantasy',
    [Pages.PREMIUM]: 'Panel Premium | Analítica Fantasy',
    [Pages.PREMIUM_ACTIVIDADES]: 'Actividades premium de Analítica Fantasy.',
    [Pages.ANALISIS_POST_PARTIDO]: 'Análisis Post Partido Premium de Analítica Fantasy.',
    [Pages.SALDO_ARBITRAL_PARTIDOS]: 'Tarjetas amarillas de equipos de La Liga',
    [Pages.SALDO_ARBITRAL_PARTIDOS_ROJAS]: 'Tarjetas rojas de equipos de La Liga',
    [Pages.CENTRO_INFORMACION]: 'Data Center de Analítica Fantasy',
    [Pages.BUSCADOR_DE_JUGADORES]: 'Buscador de jugadores de fútbol en clave La Liga Fantasy',
    [Pages.GUIAS_FANTASY]: 'Guías Fantasy de Analítica Fantasy',
    [Pages.GUIAS_FANTASY_FANTASY_MARCA]: 'Guías Fantasy Marca de Analítica Fantasy',
    [Pages.GUIAS_FANTASY_FANTASY_BIWENGER]: 'Guías Fantasy Biwenger de Analítica Fantasy',
    [Pages.GUIAS_FANTASY_FANTASY_LA_LIGA]: 'Guías La Liga Fantasy de Analítica Fantasy',
    [Pages.GUIAS_FANTASY_FANTASY_MISTER]: 'Guías Fantasy Míster de Analítica Fantasy',
    [Pages.CHOLLOS_FANTASY_MARCA]: 'Chollos Fantasy Marca de Analítica Fantasy',
    [Pages.CHOLLOS_FANTASY_MISTER]: 'Chollos Fantasy Mister de Analítica Fantasy',
    [Pages.RULETA_FANTASY]: 'Ruleta Fantasy - Pon a prueba tus conocimientos de Fantasy Fútbol',
    [Pages.RULETA_FANTASY_RANKING]: 'Ruleta Fantasy - Ranking por aciertos',
    [Pages.RULETA_FANTASY_RANKING_GLOBAL]: 'Ruleta Fantasy - Ranking Global',
};
